import React, { FC } from 'react';
import { create } from 'zustand';
import audioEffect from '~/assets/mp3/light_switches.mp3';

const audio = new Audio(audioEffect);
audio.load();

export enum OnboardingStages {
  Intro = 0,
  LanguageSelection = 1,
  Username = 2,
  CourseDuration = 3,
  Disclaimer = 4,
  PassFail = 5,
  Autosaving = 6,
  Volume = 7,
  Ready = 8,
  Outro = 9
}

interface Store {
  stage: OnboardingStages;
  next(): void;
  previous(): void;
  goTo(n: number): void;
}

export const useOnboardingStore = create<Store>(set => ({
  stage: OnboardingStages.LanguageSelection,
  next: () => {
    audio.play().catch(() => {
      // Silently ignore play interruption errors
    });
    set(s => ({ stage: s.stage + 1 }));
  },
  previous: () => {
    audio.play().catch(() => {
      // Silently ignore play interruption errors
    });
    return set(s => ({ stage: s.stage - 1 }));
  },
  goTo: n => {
    audio.play().catch(() => {
      // Silently ignore play interruption errors
    });
    return set({ stage: n });
  }
}));

export const OnboardingProvider: FC<{ children: React.ReactNode }> = ({
  children
}) => <>{children}</>;
